import { render, staticRenderFns } from "./rds-status.vue?vue&type=template&id=2cb1c0d8&scoped=true&"
import script from "./rds-status.vue?vue&type=script&lang=js&"
export * from "./rds-status.vue?vue&type=script&lang=js&"
import style0 from "./rds-status.vue?vue&type=style&index=0&id=2cb1c0d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb1c0d8",
  null
  
)

export default component.exports